import { render } from "./SpPayList_admin.vue?vue&type=template&id=13c455cb&scoped=true"
import script from "./SpPayList_admin.vue?vue&type=script&lang=js"
export * from "./SpPayList_admin.vue?vue&type=script&lang=js"

import "./SpPayList_admin.vue?vue&type=style&index=0&id=13c455cb&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c455cb"]])

export default __exports__